import { useNavigate } from "react-router-dom";
import { FC } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import SvgIcon from "@mui/material/SvgIcon";
import Divider from "@mui/material/Divider";
import useUserDataProvider from "src/contexts/userData-context";
import { QuillEditor } from "src/components/quill-editor";
import MarkEmailReadRoundedIcon from "@mui/icons-material/MarkEmailReadRounded";
import { OtherUserDataObj } from "src/types/snugtotal";
import CardActions from "@mui/material/CardActions";
import { VideoDropDownMenu } from "src/components/video-dropdown-menu";
import { usePopover } from "src/hooks/use-popover";
import { useDialog } from "src/hooks/use-dialog";
import MessageHeartSquareIcon from "src/icons/untitled-ui/duocolor/message-heart-square";
import MedicalCircleIcon from "src/icons/untitled-ui/duocolor/medical-circle";
import BankIcon from "src/icons/untitled-ui/duocolor/bank";
import Phone01Icon from "src/icons/untitled-ui/duocolor/phone-01";
import Users03Icon from "src/icons/untitled-ui/duocolor/users-03";
import Home03Icon from "src/icons/untitled-ui/duocolor/home-03";
import BoxIcon from "src/icons/untitled-ui/duocolor/box";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { VideoAskDialog } from "src/sections/dashboard/videoask-dialog";
import { HouseholdSnapshot } from "src/sections/dashboard/overview/household-snapshot";
import { HouseholdSnapshotSmall } from "src/sections/dashboard/overview/household-snapshot-small";
import { HouseholdChecklist } from "src/sections/dashboard/overview/household-checklist";
import { HouseholdContextDialog } from "src/sections/dashboard/overview/household-context-dialog";

import { Seo } from "src/components/seo";
import { usePageView } from "src/hooks/use-page-view";

import { useAuth } from "src/hooks/use-auth";
import { paths } from "src/paths";
import { useOtherUserDataStore } from "src/hooks/snug/use-otherUserData";
import { LoadingButton } from "@mui/lab";
import { useVideoAskRecordings } from "src/hooks/snug/use-videoask";

import useMediaQuery from "@mui/material/useMediaQuery";
import type { Theme } from "@mui/material/styles/createTheme";
import useHousehold, { ExperienceFlag } from "src/contexts/household-context";

export const Home: FC = () => {
  const [popoverId, setPopoverId] = useState<string | null>(null);
  const popover = usePopover<HTMLButtonElement>();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const dialog = useDialog();
  const dialogHousehold = useDialog();

  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));

  const { user } = useAuth();
  const { userData } =
    useUserDataProvider();
  const { experienceFlag } = useHousehold();
  const {
    otherUserData,
    otherUserDataSavingNew,
    otherUserDataLoading,
    handleAddOrUpdateOtherUserData,
  } = useOtherUserDataStore(userData?.ud_id || null);

  const { deleteRecording, fetchRecordings } = useVideoAskRecordings(
    userData?.ud_id || null
  );
  const navigate = useNavigate();
  // const estateDocStore = useEstateDocumentStore(userData?.ud_id || null);

  const [content, setContent] = useState<string>(
    otherUserData.words_of_wisdom || ""
  );

  // Function to handle content change
  const handleContentChange = (content: string) => {
    setContent(content);
  };

  const handleClear = () => {
    setContent("");
  };

  const handleSave = () => {
    // Here we would include the editor content in the object we want to save
    const userDataToSave: OtherUserDataObj = {
      // ...other user data fields
      id: otherUserData.id || null,
      words_of_wisdom: content,
    };
    handleAddOrUpdateOtherUserData(userDataToSave);
  };

  useEffect(() => {
    setContent(otherUserData?.words_of_wisdom || "");
  }, [otherUserData]);

  // const mostRecentOfficialHCD =
  //   estateDocStore.hcds.filter(
  //     (d) => d.type === "HEALTHCARE_DIRECTIVE" && d.status !== "IN_PROGRESS"
  //   )[0] || null;

  // const mostRecentOfficialWillOrTrust =
  //   estateDocStore.willsAndTrusts.filter(
  //     (d) => d.status !== "IN_PROGRESS"
  //   )[0] || null;

  // const mostRecentOfficialFpoa =
  //   estateDocStore.fpoas.filter(
  //     (d) =>
  //       d.type === "FINANCIAL_POWER_OF_ATTORNEY" && d.status !== "IN_PROGRESS"
  //   )[0] || null;

  // const advisorUploadProcessing =
  //   estateDocStore.estateDocuments.filter(
  //     (d) =>
  //       d.document_source === "ADVISOR_UPLOAD" &&
  //       d.status === "ANALYSIS_PENDING"
  //   ).length > 0;

  usePageView();

  const parseFirstName = (name: string | undefined): string => {
    if (name) {
      const nameArray = name.split(" ");
      return nameArray[0];
    } else {
      return "";
    }
  };

  const { selectedHousehold } = useHousehold();
  const hOH = selectedHousehold?.head_of_household;
  const estate_plan_foundation = hOH?.estate_plan_foundation;



  return (
    <>
      <Seo title="Total Estate Planning" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
          pb: 8,
          px: 0,
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent={"space-between"}
          >
            <Stack spacing={1.5} sx={{ px: { xs: 0, sm: 2, md: 4 } }}>
              <Typography color="inherit" variant="h3">
                {userData?.full_name
                  ? `Welcome, ${parseFirstName(userData?.full_name)}!`
                  : `Welcome!`}
              </Typography>

            </Stack>
          </Stack>

        </Container>


        <Box
          sx={{
            // backgroundImage:
            //   'url("https://s3.us-east-2.amazonaws.com/assets.getsnug.com/files/sand_opt.png")',
            // backgroundRepeat: "no-repeat",
            // backgroundSize: "cover",
            // backgroundPosition: { xs: "left", md: "right" },
            mt: 2,
            py: 8,
          }}
        >
          <Container maxWidth="lg">
            <Box sx={{ px: { xs: 0, sm: 2, md: 4 } }}>
              <Stack spacing={1.5}>
                {experienceFlag === ExperienceFlag.READONLY ? (
                  <Typography variant="h5" sx={{ fontWeight: 500 }}>
                    Essential documents
                  </Typography>
                ) : (
                  <Typography variant="h5" sx={{ fontWeight: 500 }}>
                    Your personalized plan
                  </Typography>
                )}
                {experienceFlag === ExperienceFlag.READONLY ? (
                  <Typography sx={{ mt: 2, pr: 3 }} variant="body2">
                    The key documents to reference for the estate plan.
                  </Typography>
                ) : (
                  <Typography sx={{ mt: 2, pr: 3 }} variant="body2">
                    A plan built around your family, your finances, and your goals.
                  </Typography>
                )}
              </Stack>
              <Divider sx={{ mt: 3, mb: 4 }} />

              <Box sx={{ mt: 5 }}>
                <Grid
                  container
                  spacing={{
                    xs: 3,
                    lg: 4,
                  }}
                  direction={{ xs: 'column-reverse', sm: 'column-reverse', md: 'column-reverse', lg: 'row' }}
                >
                  <Grid xs={12} sm={12} lg={experienceFlag === ExperienceFlag.READONLY ? 12 : 8}><HouseholdChecklist readOnly={experienceFlag === ExperienceFlag.READONLY} /></Grid>
                  {!(experienceFlag === ExperienceFlag.READONLY) &&
                  <Grid xs={12} sm={12} lg={4}>
                    {lgUp ?
                      <HouseholdSnapshot />
                      :
                      <>
                        {!estate_plan_foundation ?
                          <Box>
                            <Button variant='contained' fullWidth endIcon={<AutoAwesomeIcon fontSize='small' />}>
                              Get your personal plan
                            </Button>
                          </Box>
                          :
                          <HouseholdSnapshotSmall handleOpen={dialogHousehold.handleOpen} />
                        }
                      </>
                    }
                  </Grid>
                  }
                </Grid>
              </Box>
            </Box>
          </Container>
        </Box>

        <Container maxWidth="lg">
          <Stack spacing={3} sx={{ mb: 8, mt: 4, px: { xs: 0, sm: 2, md: 4 } }}>
            <Stack spacing={1.5}>
              <Typography variant="h5" sx={{ fontWeight: 500 }}>
                Your letter to family
              </Typography>
              <Typography sx={{ mt: 2, pr: 3 }} variant="body2">
                A letter to family can provide your thoughts and wishes for
                future generations.
              </Typography>
            </Stack>

            <Divider sx={{ mt: 3, mb: 4 }} />

            <Box sx={{ mt: 5 }}></Box>

            <Grid
              container
              spacing={{
                lg: 0,
              }}
            >
              <Grid xs={12} sm={12} lg={12}>
                <Stack spacing={3}>
                  <QuillEditor
                    value={content}
                    onChange={handleContentChange}
                    readOnly={
                      experienceFlag === ExperienceFlag.READONLY ||
                      otherUserDataLoading
                    }
                    placeholder="Write your letter to family"
                    sx={{ height: 330, mr: 4 }}
                    modules={
                      experienceFlag === ExperienceFlag.READONLY
                        ? { toolbar: false }
                        : { toolbar: true }
                    }
                  />
                  <Stack direction="row" spacing={2}>
                    <LoadingButton
                      variant="contained"
                      disabled={
                        experienceFlag === ExperienceFlag.READONLY ||
                        otherUserDataLoading
                      }
                      loading={otherUserDataSavingNew}
                      startIcon={<MarkEmailReadRoundedIcon />}
                      onClick={handleSave}
                      sx={{ borderRadius: 100 }}
                    >
                      Save changes
                    </LoadingButton>
                    <Button
                      variant="text"
                      disabled={experienceFlag === ExperienceFlag.READONLY}
                      color="inherit"
                      onClick={handleClear}
                      sx={{ borderRadius: 100 }}
                    >
                      Clear
                    </Button>
                  </Stack>
                </Stack>
              </Grid>

            </Grid>
          </Stack>

          <Stack spacing={3} sx={{ mb: 8, mt: 4, px: { xs: 0, sm: 2, md: 4 } }}>
            <Stack spacing={3}>
              <Stack spacing={1.5}>
                {experienceFlag === ExperienceFlag.READONLY ? (
                  <Typography variant="h5" sx={{ fontWeight: 500 }}>
                    Other important details
                  </Typography>
                ) : (
                  <Typography variant="h5" sx={{ fontWeight: 500 }}>
                    Your life's details
                  </Typography>
                )}

                {experienceFlag === ExperienceFlag.READONLY ? (
                  <Typography sx={{ mt: 2, pr: 3 }} variant="body2">
                    View and reference all of life's other important details in
                    one place.
                  </Typography>
                ) : (
                  <Typography sx={{ mt: 2, pr: 3 }} variant="body2">
                    Organizing all of life's details in one place, to leave a
                    legacy and not a mess.
                  </Typography>
                )}
              </Stack>

              <Divider sx={{ mt: 3, mb: 4 }} />

              <Box sx={{ mt: 5 }}></Box>

              <Stack spacing={3}>
                <Box>
                  <Grid
                    container
                    spacing={{
                      xs: 3,
                      lg: 4,
                    }}
                  >
                    <Grid xs={6} sm={4} lg={3}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          // border: "none",
                          cursor: "pointer",
                          backgroundColor: "#FAF9F8",
                        }}
                        onClick={() => navigate(paths.dashboard.personal(userData?.ud_id || ""))}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                          }}
                        >
                          <Stack direction="row" spacing={2}>
                            <SvgIcon>
                              <Users03Icon />
                            </SvgIcon>

                            <Typography
                              color="text.primary"
                              variant="subtitle1"
                            >
                              Personal
                            </Typography>
                          </Stack>
                          <Typography
                            color="text.secondary"
                            sx={{ mt: 1, flex: 1 }}
                            variant="body2"
                          >
                            Personal contacts, pets, advisors, and personal
                            history.
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            color="inherit"
                            endIcon={
                              <SvgIcon>
                                <ArrowForwardOutlinedIcon />
                              </SvgIcon>
                            }
                            size="small"
                            onClick={() => navigate(paths.dashboard.personal(userData?.ud_id || ""))}
                          >
                            Get started
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                    <Grid xs={6} sm={4} lg={3}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          // border: "none",
                          backgroundColor: "#FAF9F8",
                        }}
                        onClick={() => navigate(paths.dashboard.legal(userData?.ud_id || ""))}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                          }}
                        >
                          <Stack direction="row" spacing={2}>
                            <SvgIcon>
                              <BoxIcon />
                            </SvgIcon>
                            <Typography
                              color="text.primary"
                              variant="subtitle1"
                            >
                              Legal
                            </Typography>
                          </Stack>
                          <Typography
                            color="text.secondary"
                            sx={{ mt: 1, flex: 1 }}
                            variant="body2"
                          >
                            Estate planning, marriage and divorce, business
                            documents.
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            color="inherit"
                            endIcon={
                              <SvgIcon>
                                <ArrowForwardOutlinedIcon />
                              </SvgIcon>
                            }
                            size="small"
                            onClick={() => navigate(paths.dashboard.legal(userData?.ud_id || ""))}
                          >
                            Get started
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>

                    <Grid xs={6} sm={4} lg={3}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          // border: "none",
                          backgroundColor: "#FAF9F8",
                        }}
                        onClick={() => navigate(paths.dashboard.medical(userData?.ud_id || ""))}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                          }}
                        >
                          <Stack direction="row" spacing={2}>
                            <SvgIcon>
                              <MedicalCircleIcon />
                            </SvgIcon>
                            <Typography
                              color="text.primary"
                              variant="subtitle1"
                            >
                              Medical
                            </Typography>
                          </Stack>
                          <Typography
                            color="text.secondary"
                            sx={{ mt: 1, flex: 1 }}
                            variant="body2"
                          >
                            Medical contacts, history, allergies, and current
                            medications.
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            color="inherit"
                            endIcon={
                              <SvgIcon>
                                <ArrowForwardOutlinedIcon />
                              </SvgIcon>
                            }
                            size="small"
                            onClick={() => navigate(paths.dashboard.medical(userData?.ud_id || ""))}
                          >
                            Get started
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>

                    <Grid xs={6} sm={4} lg={3}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          // border: "none",
                          backgroundColor: "#FAF9F8",
                        }}
                        onClick={() => navigate(paths.dashboard.financial(userData?.ud_id || ""))}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                          }}
                        >
                          <Stack direction="row" spacing={2}>
                            <SvgIcon>
                              <BankIcon />
                            </SvgIcon>
                            <Typography
                              color="text.primary"
                              variant="subtitle1"
                            >
                              Financial
                            </Typography>
                          </Stack>
                          <Typography
                            color="text.secondary"
                            sx={{ mt: 1, flex: 1 }}
                            variant="body2"
                          >
                            List of assets, debts, and insurance to ease estate
                            settlement effort.
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            color="inherit"
                            endIcon={
                              <SvgIcon>
                                <ArrowForwardOutlinedIcon />
                              </SvgIcon>
                            }
                            size="small"
                            onClick={() => navigate(paths.dashboard.financial(userData?.ud_id || ""))}
                          >
                            Get started
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>

                    <Grid xs={6} sm={4} lg={3}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          // border: "none",
                          backgroundColor: "#FAF9F8",
                        }}
                        onClick={() => navigate(paths.dashboard.property(userData?.ud_id || ""))}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                          }}
                        >
                          <Stack direction="row" spacing={2}>
                            <SvgIcon>
                              <Home03Icon />
                            </SvgIcon>
                            <Typography
                              color="text.primary"
                              variant="subtitle1"
                            >
                              Property
                            </Typography>
                          </Stack>
                          <Typography
                            color="text.secondary"
                            sx={{ mt: 1, flex: 1 }}
                            variant="body2"
                          >
                            Inventory of vehicles, real estate, family
                            heirlooms, and other personal property.
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            color="inherit"
                            endIcon={
                              <SvgIcon>
                                <ArrowForwardOutlinedIcon />
                              </SvgIcon>
                            }
                            size="small"
                            onClick={() => navigate(paths.dashboard.property(userData?.ud_id || ""))}
                          >
                            Get started
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>

                    <Grid xs={6} sm={4} lg={3}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          // border: "none",
                          backgroundColor: "#FAF9F8",
                        }}
                        onClick={() => navigate(paths.dashboard.digital(userData?.ud_id || ""))}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                          }}
                        >
                          <Stack direction="row" spacing={2}>
                            <SvgIcon>
                              <Phone01Icon />
                            </SvgIcon>
                            <Typography
                              color="text.primary"
                              variant="subtitle1"
                            >
                              Digital
                            </Typography>
                          </Stack>
                          <Typography
                            color="text.secondary"
                            sx={{ mt: 1, flex: 1 }}
                            variant="body2"
                          >
                            Social media, cloud storage, photo services, and
                            more digital assets.
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            color="inherit"
                            endIcon={
                              <SvgIcon>
                                <ArrowForwardOutlinedIcon />
                              </SvgIcon>
                            }
                            size="small"
                            onClick={() => navigate(paths.dashboard.digital(userData?.ud_id || ""))}
                          >
                            Get started
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>

                    <Grid xs={6} sm={4} lg={3}>
                      <Card
                        variant="outlined"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          // border: "none",
                          backgroundColor: "#FAF9F8",
                        }}
                        onClick={() => navigate(paths.dashboard.legacy(userData?.ud_id || ""))}
                      >
                        <CardContent
                          sx={{
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            pb: 2,
                          }}
                        >
                          <Stack direction="row" spacing={2}>
                            <SvgIcon>
                              <MessageHeartSquareIcon />
                            </SvgIcon>
                            <Typography
                              color="text.primary"
                              variant="subtitle1"
                            >
                              Legacy
                            </Typography>
                          </Stack>
                          <Typography
                            color="text.secondary"
                            sx={{ mt: 1, flex: 1 }}
                            variant="body2"
                          >
                            Family history and words of wisdom to pass along to
                            the next generation.
                          </Typography>
                        </CardContent>
                        <Divider />
                        <CardActions>
                          <Button
                            color="inherit"
                            endIcon={
                              <SvgIcon>
                                <ArrowForwardOutlinedIcon />
                              </SvgIcon>
                            }
                            size="small"
                            onClick={() => navigate(paths.dashboard.legacy(userData?.ud_id || ""))}
                          >
                            Get started
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
              </Stack>
            </Stack>
          </Stack>
        </Container>
      </Box>
      <VideoDropDownMenu
        anchorEl={anchorEl}
        onClose={() => {
          setPopoverId(null);
          setAnchorEl(null);
          popover.handleClose();
        }}
        recordingId={popoverId}
        open={popover.open}
        handleRemoveVideo={deleteRecording}
      />
      <VideoAskDialog
        // on close, handleClose, then wait a second and to then call fetchRecordings
        onClose={() => {
          dialog.handleClose();
          if (userData?.ud_id) {
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 1000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 3000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 5000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 7000);
            setTimeout(() => fetchRecordings(userData.ud_id || ""), 10000);
          }
        }}
        open={dialog.open}
        email={user?.username || null}
      />
      <HouseholdContextDialog
        onClose={dialogHousehold.handleClose}
        open={dialogHousehold.open}
      />
    </>
  );
};
